import { ReactNode } from 'react';
import { CatCheckboxField } from '@blocks-react/components/CheckboxField';
import { useCheckboxController } from '../../../hooks/form-controllers';
import styles from '../DealerLocator.module.scss';

export interface DealerLocatorTermsCheckboxProps {
  children?: ReactNode;
  title: string;
  label?: string;
  isDisabled?: boolean;
}

const TERMS_CHECKBOX_ID = 'termsChecked';

export const DealerLocatorTermsCheckbox = ({
  children,
  title,
  label,
  isDisabled,
}: DealerLocatorTermsCheckboxProps) => {
  const { booleanCheckboxField } = useCheckboxController({
    name: TERMS_CHECKBOX_ID,
    rules: { required: true },
  });
  return (
    <div className="mt-2 mb-4">
      <CatCheckboxField {...booleanCheckboxField} disabled={isDisabled}>
        <div className="cat-u-theme-typography-label">
          {title}
          {!!label && (
            <span className={styles['terms-checkbox-label']}>{label}</span>
          )}
        </div>
        <span slot="field-note">{children}</span>
      </CatCheckboxField>
    </div>
  );
};
